<template>
  <div id="trending-analysis-page">
    <page-header-component
      icon="bi bi-graph-up"
      title="Trending Analysis"
      @filterChange="filterChange"
    />
    <div class="row">
      <div class="col-md-12 px-gap">
        <div class="card m-b-10 shade">
          <div class="card-body">
            <div class="row clearfix">
              <div class="col-md-6" id="topicPolarity">
                <center v-if="circleLoading">
                  <loader-component />
                </center>
                <div v-else class="row clearfix">
                  <div
                    v-for="data in dataProgress.data"
                    :key="data.name"
                    class="col-md-6 text-center mb-4"
                  >
                    <p style="font-size: 15x">
                      <b>{{ data.name }}</b>
                    </p>
                    <p style="font-size: 30px">
                      <b> + </b>
                    </p>
                    <center>
                      <progress-circle
                        :completed-steps="data.percent"
                        :total-steps="100"
                        :circle-color="'#CCD1D1'"
                        :start-color="data.percent >= 0 ? '#28a745' : '#dc3545'"
                        :stop-color="data.percent >= 0 ? '#28a745' : '#dc3545'"
                      >
                        <p class="font-weight-bolder h5">
                          {{ Math.round(data.percent) }}%
                        </p>
                      </progress-circle>
                    </center>
                  </div>
                </div>
              </div>
              <div class="col-md-6" id="sentimentViral">
                <center v-if="sentimentLoading">
                  <loader-component />
                </center>
                <highcharts
                  v-else
                  :options="dataSentiment"
                  :key="keySentiment"
                ></highcharts>
              </div>
            </div>
            <p style="font-size: 13px">
              <i>Perkembangan Viralitas Isu 24 Jam Terakhir.</i>
            </p>
            <div class="row clearfix">
              <div class="col-md-12" id="viralHourly">
                <center v-if="lineLoading">
                  <loader-component />
                </center>
                <highcharts
                  v-else
                  :options="dataViral"
                  :key="keyViral"
                ></highcharts>
              </div>
            </div>
            <br />
            <div>
              <div class="col-md-12" id="topikIsu">
                <table class="table table-bordered table-resposive" id="trend_table">
                  <thead>
                    <tr>
                      <th>Topik</th>
                      <th width="15%" class="text-center">Engagement</th>
                      <th width="15%" class="text-center">Reach</th>
                    </tr>
                  </thead>
                  <tbody></tbody>
                </table>
                <div class="form-group">
                  <pagination-component
                    v-if="page_info != null"
                    :key="pagination_key"
                    class="pull-left"
                    :data="page_info"
                    :goto="true"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import page_header from "@/views/components/page_header.vue";
import { Chart } from "highcharts-vue";
import pagintaion_component from "@/views/components/pagination.vue";
import loader_component from "@/views/components/loader.vue";
import { ProgressCircle } from "vue-progress-circle";

export default {
  name: "TrendingAnalysis",
  title: "Analytics Trending Analysis | Online Media Monitoring",
  components: {
    "page-header-component": page_header,
    "pagination-component": pagintaion_component,
    "loader-component": loader_component,
    highcharts: Chart,
    ProgressCircle,
  },
  data() {
    return {
      id_project: this.$store.getters.user.id_project,
      viralCategories: null,
      viralSeries: null,
      dataTable: {},
      dataViral: {},
      dataQuadrant: {},
      dataSentiment: {},
      dataProgress: {},
      keySentiment: 20,
      keyViral: 10,
      page_info: null,
      pagination_key: 0,
      keyTable: 10,
      circleLoading: true,
      tableLoading: true,
      lineLoading: true,
      sentimentLoading: true,
    };
  },
  methods: {
    filterChange: function () {
      this.circleLoading = true;
      this.tableLoading = true;
      this.lineLoading = true;
      this.sentimentLoading = true;
      this.getDataProgressCircle();
      this.getDataViral();
      this.getDataSentiment();
      this.getDataTable();
      this.table = $("#trend_table").DataTable();
    },
    getDataProgressCircle: function () {
      let api =
        process.env.VUE_APP_API_URL + "trending/polarity/" + this.id_project;
      let query = {
        from: this.$route.query.from,
        to: this.$route.query.to,
      };
      this.$http
        .get(api, { params: query })
        .then((response) => {
          if (response.status == 200) {
            this.dataProgress = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.circleLoading = false;
          this.setDataViral();
        });
    },
    getDataTable: function () {
      let self = this;
      let api =
        process.env.VUE_APP_API_URL + "trending/table/" + this.id_project;
      this.$http.get(api).then((response) => {
        if (response.status == 204) {
          self.dataTable = {};
          self.page_info = null;
        } else {
          self.table.clear().draw();
          self.dataTable = response.data;
          for (let index in self.dataTable) {
            let topik = self.dataTable[index].name;
            let engagement = self.dataTable[index].engagement;
            let reach = Math.round(self.dataTable[index].esmr);
            self.table.row
              .add([
                topik,
                `<center>${engagement}</center>`,
                `<center>${reach}</center>`,
              ])
              .node().id = index;
            self.table.columns.adjust().draw();
          }
        }
      });
    },
    getDataViral: function () {
      let api =
        process.env.VUE_APP_API_URL + "trending/virality/" + this.id_project;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            this.viralCategories = response.data.date;
            this.viralSeries = response.data.series;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.lineLoading = false;
          this.setDataViral();
        });
    },
    setDataViral: function () {
      this.dataViral = {
        chart: {
          type: "spline",
        },
        credits: {
          enabled: false,
        },
        title: {
          text: "",
        },
        xAxis: [
          {
            categories: this.viralCategories,
            crosshair: true,
            title: {
              text: "Waktu (WIB)",
            },
          },
        ],
        yAxis: {
          labels: {
            format: "{value}",
          },
          title: {
            text: "Virality",
          },
        },

        tooltip: {
          shared: true,
        },
        legend: {
          layout: "horizontal",
          align: "center",
          verticalAlign: "bottom",
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false,
            },
          },
        },
        series: this.viralSeries,
      };
      this.keyViral++;
    },
    getDataSentiment: function () {
      let api =
        process.env.VUE_APP_API_URL + "trending/quadrant/" + this.id_project;
      let query = {
        from: this.$route.query.from,
        to: this.$route.query.to,
      };
      this.$http
        .get(api, { params: query })
        .then((response) => {
          if (response.status == 204) {
            this.dataQuadrant = {
              name: "",
              data: [{ x: "", y: 0, engagement: "" }],
            };
          } else {
            this.dataQuadrant = response.data.series;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.sentimentLoading = false;
          this.setDataSentiment();
        });
    },
    setDataSentiment: function () {
      let data = this.dataQuadrant;
      this.dataSentiment = {
        chart: {
          type: "scatter",
          zoomType: "xy",
        },
        credits: {
          enabled: false,
        },
        title: {
          text: "",
        },
        xAxis: {
          title: {
            text: "Sentiment",
            rotation: 0,
            margin: 25,
          },
          min: -100,
          max: 100,
          tickLength: 0,
          minorTickLength: 0,
          gridLineWidth: 1,
          showLastLabel: true,
          showFirstLabel: false,
          lineColor: "#ccc",
          lineWidth: 1,
        },
        legend: {
          enabled: false,
          align: "right",
          verticalAlign: "top",
          layout: "vertical",
        },
        yAxis: {
          title: {
            text: "Viralitas",
            rotation: 90,
            margin: 25,
          },
          labels: {
            enabled: false,
          },
          min: 0,
          max: 100,
          tickLength: 3,
          minorTickLength: 0,
          lineColor: "#ccc",
          lineWidth: 1,
        },
        plotOptions: {
          area: {
            enableMouseTracking: false,
            marker: {
              enabled: false,
            },
            states: {
              inactive: {
                opacity: 1,
              },
            },
          },
          scatter: {
            marker: {
              width: 30,
              height: 30,
            },
            dataLabels: {
              enabled: true,
              formatter: function () {
                return this.series.name;
              },
            },
            point: {
              events: {
                click: function () {
                  console.log("");
                },
              },
            },
          },
        },
        series: (function () {
          var series = data;
          series.push(
            {
              name: "Tidak Viral & Positif",
              type: "area",
              fillOpacity: 0.4,
              data: [
                [0, 0],
                [100, 0],
                [100, 50],
                [0, 50],
              ],
              lineWidth: 0,
              color: "#D8D53A",
            },
            {
              name: "Tidak Viral & Negatif",
              type: "area",
              fillOpacity: 0.4,
              data: [
                [-100, 0],
                [0, 0],
                [0, 50],
                [-100, 50],
              ],
              lineWidth: 0,
              color: "#21618C",
            },
            {
              name: "Viral & Negatif",
              type: "area",
              fillOpacity: 0.4,
              data: [
                [-100, 50],
                [0, 50],
                [0, 100],
                [-100, 100],
              ],
              lineWidth: 0,
              color: "#922B21",
            },
            {
              name: "Viral & Positif",
              type: "area",
              fillOpacity: 0.4,
              data: [
                [0, 50],
                [100, 50],
                [100, 100],
                [0, 100],
              ],
              lineWidth: 0,
              color: "#219221",
            }
          );
          return series;
        })(),
      };
      this.keySentiment++;
    },
  },

  mounted: function () {
    this.getDataProgressCircle();
    this.getDataViral();
    this.getDataSentiment();
    this.getDataTable();
    this.table = $("#trend_table").DataTable();
  },
};
</script>
